import { render, staticRenderFns } from "./DoKubSummary.vue?vue&type=template&id=1301b6ca&"
import script from "./DoKubSummary.vue?vue&type=script&lang=js&"
export * from "./DoKubSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports